<template>
  <div v-if="letter.id">
    <div
      class="row"
    >
      <div class="col-md-12">
        <b-card
          no-body
        >
          <div class="m-2">
            <div class="row">
              <div class="col-md-6">
                <table class="table table-bordered">
                  <tr>
                    <th>{{ $t('Code') }}</th>
                    <td> {{ letter.code }}</td>
                  </tr>
                  <tr>
                    <th>{{ $t('Short Info') }}</th>
                    <td> {{ letter.short_info }}</td>
                  </tr>
                  <tr v-if="true">
                    <th colspan="2">
                      <b-link :to="{ name: 'quote-distribution-ask-list' }">
                        {{ $t('Ask additional quote') }}
                      </b-link>
                    </th>
                  </tr>
                </table>
              </div>
              <div class="col-md-6">
                <table class="table table-bordered">
                  <tr>
                    <th>{{ $t('Step') }}</th>
                    <td>
                      {{ letter.quote_step }}
                    </td>
                  </tr>
                  <tr>
                    <th>{{ $t('Period') }}</th>
                    <td> {{ letter.period.name }}</td>
                  </tr>
                </table>
              </div>
            </div>
          </div>
        </b-card>
      </div>
    </div>

    <b-card
      v-if="canSend(letter)"
      no-body
    >
      <b-table
        :fields="fields"
        :items="balance ? [{}]: []"
        class="table-bordered"
      >
        <template #thead-top="">
          <b-tr>
            <b-th
              colspan="5"
              class="text-center"
              style="background: none"
            >
              {{ $t("Quota available in the organization for {year}", { year: letter.period.admission_year }) }}
            </b-th>
          </b-tr>
        </template>
        <template #head()="data">
          {{ getHead(data) }}
        </template>
        <template #cell()="data">
          {{ getValueOfItemInBalance(data.field.data) }}
        </template>
      </b-table>
    </b-card>
    <b-card no-body>
      <div class="m-1">
        <h4 class="text-center">
          {{ $t("Allocated quota for {year}", { year: letter.period.admission_year }) }}
        </h4>
        <hr>
        <!-- Table Top -->
        <b-row>

          <!-- Search -->
          <b-col
            cols="12"
            md="6"
          >
            <div class="d-flex align-items-center justify-content-end">
              <b-form-input
                v-model="searchQuery"
                class="d-inline-block mr-1"
                :placeholder="$t('Search')"
              />
            </div>
          </b-col>
        </b-row>
      </div>
      <b-table
        id="otmItmAcceptedLetterQuotesTable"
        :fields="fieldsAccepted"
        :items="orgDistributedQuotes"
        :filter="searchQuery"
        class="table-responsive table-bordered"
      >
        <template
          v-for="dcType in dcTypes"
          v-slot:[`head(${dcType.id})`]=""
        >
          {{ $langName(getDcType(dcType.id).name) }}
        </template>
        <template
          v-for="dcType in dcTypes"
          v-slot:[`cell(${dcType.id})`]="data"
        >
          {{ getCellValueByDcType(data.item.quote_dc_types, dcType) }}
        </template>

        <template #head()="data">
          {{ getHead(data) }}
        </template>
        <template #cell(index)="data">
          {{ data.index + 1 }}
        </template>
        <template #cell(direction)="data">
          {{ data.value.code + ' - ' +$langName(data.value.name) }}
        </template>
        <template #cell(actions)="data">
          <feather-icon
            v-b-toggle.sidebar-update-quote-distribution-item
            icon="EditIcon"
            class="text-primary cursor-pointer mr-1"
            size="16"
            :title="$t('Update')"
            @click="showUpdate(data)"
          />
        </template>
      </b-table>
      <update-item @refetchData="loadOrgDistributedQuotes(); loadBalance()" />
      <b-button
        v-if="canSend(letter)"
        variant="primary"
        class="btn btn-primary ml-auto m-2"
        @click="send"
      >
        <feather-icon
          icon="SendIcon"
          class="mr-50"
        />
        <span>{{ $t('Confirm') }}</span>
      </b-button>
    </b-card>
  </div>
</template>

<script>
import {
  BCard, BTable, VBToggle, BCol, BRow, BFormInput,
  BButton, BTh, BTr, BLink,
} from 'bootstrap-vue'
import store from '@/store'
import permission from './permission'
import UpdateItem from './UpdateItem.vue'
import { myOrganization } from '@/auth/utils'

export default {
  components: {
    BCard,
    BTable,
    UpdateItem,
    BCol,
    BRow,
    BFormInput,
    BButton,
    BTh,
    BTr,
    BLink,
  },
  directives: {
    'b-toggle': VBToggle,
  },
  computed: {
    letter() {
      return this.$store.state[this.MODULE_NAME].letter
    },
    orgDistributedQuotes() {
      return this.$store.state[this.MODULE_NAME].orgDistributedQuotes
    },
    dcTypes() {
      return this.$store.getters['staticModule/getSimpleDcTypes']
    },
    balance() {
      return this.$store.state[this.MODULE_NAME].balance
    },
  },
  created() {
    this.refetchData()
    const { dcTypes } = this
    dcTypes.forEach(dcType => {
      this.fieldsAccepted.push({
        key: `${dcType.id}`,
        thClass: 'h6',
      })
      if (dcType.id !== this.traineeResearcher) {
        this.fields.push({
          key: `${dcType.id}`,
          label: `${dcType.id}`,
          data: {
            org_type: (myOrganization() && myOrganization().org_type === this.orgTypeITM) ? this.quoteOrgTypeITM : this.quoteOrgTypeOTM,
            dc_type: dcType.id,
          },
        })
      }
    })
    this.fieldsAccepted.push({
      key: 'actions',
      label: '',
    })
    this.fields.push({
      key: 'trainee_researcher',
      label: `${this.traineeResearcher}`,
      data: { org_type: this.quoteOrgTypeCommon, dc_type: this.traineeResearcher },
    })
  },
  methods: {
    showUpdate(data) {
      this.$store.commit(`${this.MODULE_NAME}/SET_QUOTE_DISTRIBUTION_ITEM`, data.item)
      this.$store.commit(`${this.MODULE_NAME}/SET_QUOTE_DISTRIBUTION_ITEM_DC_TYPES`, data.item.quote_dc_types.filter(x => !this.isDcTypeIndependentResearcher(x.dc_type)))
    },
    refetchData() {
      this.loadOrgDistributedQuotes()
      this.loadBalance()
    },
    loadOrgDistributedQuotes() {
      this.$store.dispatch(`${this.MODULE_NAME}/orgDistributedQuote`, { period_id: this.letter.period.id })
    },
    loadBalance() {
      if (myOrganization()) {
        this.$store.dispatch(`${this.MODULE_NAME}/getBalance`, { period_id: this.letter.period.id, org_id: myOrganization().id })
      }
    },
    getDcType(id) {
      return this.$store.getters['staticModule/getDcType'](id)
    },
    getHead(head) {
      const col = head.label
      if (Number(col) >= 100 && Number(col) <= 700) {
        return this.$langName(this.getDcType(Number(col)).name)
      }
      return this.$t(col)
    },
    getCellValueByDcType(list, dcType) {
      for (let i = 0; i < list.length; i += 1) {
        const item = list[i]
        if (item.dc_type === dcType.id) {
          return `${Number(item.confirmed_amount)} / ${item.amount}`
        }
      }
      return '-'
    },
    getQuoteOrgType(id) {
      return this.$store.getters['staticModule/getQuoteOrgType'](id)
    },
    isDcTypeIndependentResearcher(dcType) {
      const { independentResearcherDSc, independentResearcherPhD } = this.$store.state.staticModule
      return dcType === independentResearcherDSc || dcType === independentResearcherPhD
    },
    getValueOfItemInBalance(data) {
      let res = 0
      this.balance.forEach(orgTypes => {
        if (orgTypes.org_type === data.org_type) {
          orgTypes.sum.forEach(item => {
            if (item.dc_type === data.dc_type) {
              res += item.sum
            }
          })
        }
      })
      return res
    },
    send() {
      this.$removeSwal(this, this.letter.id, `${this.MODULE_NAME}/changeLetterQuoteStep`, this.refetchData, {
        text: '',
        confirmButtonText: 'Tasdiqlash',
        successTitle: 'Tasdiqlandi!',
        successText: 'Kvota tasdiqlandi',
        errorText: 'Kvota taqsimlanmadi! Xatolik bor!',
      })
    },
  },
  setup() {
    const {
      traineeResearcher,
      quoteOrgTypeOTM, quoteOrgTypeITM, quoteOrgTypeCommon,
      orgTypeITM,
    } = store.state.staticModule
    const fieldsAccepted = [
      { key: 'index', label: '#' },
      { key: 'direction', label: 'Direction' },
    ]
    const fields = []
    const searchQuery = ''
    const MODULE_NAME = 'quoteDistributionOtm'

    return {
      MODULE_NAME,
      fieldsAccepted,
      fields,
      ...permission(),
      searchQuery,
      traineeResearcher,
      quoteOrgTypeCommon,
      quoteOrgTypeITM,
      quoteOrgTypeOTM,
      orgTypeITM,
    }
  },
}
</script>

<style>
</style>
